import React from "react";
import Icon from "components/AppIcon";

export default function KPICard({ title, value, change, changeLabel, icon, iconColor, trend, prefix, suffix }) {
  const hasChange = change != null;
  const isPositive = (change ?? 0) >= 0;
  const trendColor = trend === "up-good" ? (isPositive ?"var(--color-success)" : "var(--color-error)")
    : (isPositive ? "var(--color-error)" : "var(--color-success)");

  return (
    <div
      className="card-base flex flex-col gap-3 min-w-0"
      style={{ background: "var(--color-card)", borderRadius: "var(--radius-md)" }}
    >
      <div className="flex items-center justify-between gap-2">
        <span
          className="font-caption text-xs font-medium uppercase tracking-wide truncate"
          style={{ color: "var(--color-text-secondary)" }}
        >
          {title}
        </span>
        <div
          className="flex items-center justify-center rounded-md flex-shrink-0"
          style={{
            width: "36px",
            height: "36px",
            background: `${iconColor}18`,
            borderRadius: "var(--radius-sm)",
          }}
        >
          <Icon name={icon} size={18} color={iconColor} strokeWidth={2} />
        </div>
      </div>

      <div className="flex flex-col gap-1">
        <span
          className="font-heading font-bold leading-none"
          style={{ fontSize: "clamp(1.5rem, 3vw, 2rem)", color: "var(--color-foreground)" }}
        >
          {prefix && <span style={{ fontSize: "0.7em", fontWeight: 600 }}>{prefix}</span>}
          {value}
          {suffix && <span style={{ fontSize: "0.7em", fontWeight: 600 }}>{suffix}</span>}
        </span>
      </div>

      <div className="flex items-center gap-1.5 flex-wrap">
        {hasChange ? (
          <div
            className="flex items-center gap-0.5 px-1.5 py-0.5 rounded"
            style={{ background: `${trendColor}15` }}
          >
            <Icon
              name={isPositive ? "TrendingUp" : "TrendingDown"}
              size={12}
              color={trendColor}
              strokeWidth={2.5}
            />
            <span
              className="font-data text-xs font-semibold"
              style={{ color: trendColor }}
            >
              {isPositive ? "+" : ""}{change}%
            </span>
          </div>
        ) : null}
        <span className="font-caption text-xs" style={{ color: "var(--color-text-secondary)" }}>
          {changeLabel}
        </span>
      </div>
    </div>
  );
}